export default "__VITE_ASSET__Cy$Xb1kP__"